// src/pages/MyQueue.js
import React from "react";
import { useQueue } from "../context/QueueContext";
import ArticleCard from "../components/ArticleCard";

function MyQueue() {
  const { queue } = useQueue();

  // Handle swipe right or button click to add to queue
  const handleAddToQueue = (article) => {
    queue(article);
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>My Queue</h2>
      {queue.length === 0 ? (
        <p>No articles in your queue yet.</p>
      ) : (
        queue.map((article) => (
          <ArticleCard key={article.id} article={article} onSwipeRight={() => handleAddToQueue(article)}/>
        ))
      )}
    </div>
  );
}

export default MyQueue;